import actions from './actions';

const {
  GET_DATA_TEMPLATES,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  SET_DATA_TEMPLATES,
  SET_NEW_DATA_TEMPLATE,
  EDIT_DATA_TEMPLATE,
  DELETE_DATA_TEMPLATE,
} = actions;

const initialState = {
  data: [],
  total: 0,
  page: 1,
  totalPages: 1,
  loading: false,
};

const templatesReducer = (state = initialState, action:any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_TEMPLATES:
      return {
        ...state
      };
    case GET_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FINISH:
      return {
        ...state,
        loading: false,
      };
    case SET_DATA_TEMPLATES:
      return {
        ...state,
        data: data.results,
        total: data.totalResults,
        page: data.page,
        totalPages: data.totalPages,
        loading: false,
      };
    case SET_NEW_DATA_TEMPLATE:
      return {
        ...state,
        data: [data, ...state.data],
      };
    case EDIT_DATA_TEMPLATE:
      const index = state.data.findIndex((template:any) => template.id === data.id);
      let newArray:any = [...state.data];
      newArray[index] = data;
      return {
        ...state,
        data: newArray
      };
    case DELETE_DATA_TEMPLATE:
      return {
        ...state,
        data: [...state.data.filter((template:any) => template.id !== data.id)]
      };
    default:
      return state;
  }
};
export { templatesReducer };
